/**
 * StoreDeactivateModal — prompt admin for a reason before stopping an active store.
 * The reason is forwarded to the merchant via email.
 */
import { Loader2, Ban } from 'lucide-react';
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';

export default function StoreDeactivateModal({
  open,
  onOpenChange,
  selectedStore,
  reason,
  setReason,
  onConfirm,
  processing,
  language = 'ar',
}) {
  const isAr = language === 'ar';
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#1a1a2e] border-[#2a2a4e] text-white max-w-lg"
        data-testid="store-deactivate-modal"
      >
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Ban className="h-5 w-5 text-red-500" />
            {isAr ? 'إيقاف المتجر' : 'Stop Store'}
          </DialogTitle>
          <DialogDescription className="text-[#808080]">
            {isAr
              ? `سيتم إيقاف "${selectedStore?.name || ''}" وإرسال إشعار بالبريد إلى صاحب المتجر.`
              : `Store "${selectedStore?.name || ''}" will be stopped and the owner will be notified by email.`}
          </DialogDescription>
        </DialogHeader>

        <div className="py-3">
          <label className="text-sm text-[#808080] mb-2 block">
            {isAr ? 'سبب الإيقاف (يُرسل للمالك):' : 'Reason (sent to the owner):'}
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={isAr ? 'اكتب رسالة موضحاً سبب الإيقاف...' : 'Write a message explaining why...'}
            rows={5}
            data-testid="deactivate-reason-input"
            className="w-full p-3 bg-[#0a0a0a] border border-[#2a2a4e] rounded-xl text-white text-sm focus:border-red-500/50 focus:outline-none resize-y"
          />
          <p className="text-xs text-[#606060] mt-2">
            {isAr
              ? 'ملاحظة: يمكنك ترك الحقل فارغاً، لكن إعطاء سبب يساعد المالك على فهم الإجراء.'
              : 'Tip: you may leave the field empty, but giving a reason helps the owner understand.'}
          </p>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-[#2a2a4e] text-white"
            data-testid="deactivate-cancel-btn"
          >
            {isAr ? 'إلغاء' : 'Cancel'}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={processing}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="deactivate-confirm-btn"
          >
            {processing ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <>
                <Ban className="h-4 w-4 me-2" />
                {isAr ? 'تأكيد الإيقاف' : 'Confirm Stop'}
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
